/* eslint-disable prefer-template */
const formatDropdownVesselGroup = (array, labelField, valueField, extraLabel) => {
    if (!Array.isArray(array) || array.length === 0) return [];
    return array.map((item) => {
      if (!item || typeof item !== 'object') return null;
      let label = item[labelField] || '';
      if (item[extraLabel]) {
        label += ' ' + item[extraLabel];
      }
      return {
        ...item,
        label,
        value: item?.[valueField] ?? '',
        imo: item?.imoNumber,
        vesselCode: item?.vesselCode
      };
    }).filter(Boolean);
  };
  export default formatDropdownVesselGroup;
